// extracted by mini-css-extract-plugin
module.exports = {"content":"LeaveReviewForm_content__ekw2S","form":"LeaveReviewForm_form__ozERo","field":"LeaveReviewForm_field__lM8Qt"};